import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@carbon/react';

import { formatArea } from 'utils/format';

const SiteSpecificSpacesBreakdownTable = ({ siteSpecificSpaces, measurementSystem }) => (
  <Table size="sm">
    <TableHead>
      <TableRow>
        <TableHeader>Name</TableHeader>
        <TableHeader>Area</TableHeader>
      </TableRow>
    </TableHead>
    <TableBody>
      {siteSpecificSpaces.map((space) => (
        <TableRow key={space.id}>
          <TableCell>
            <strong>{space.name}</strong>
          </TableCell>
          <TableCell>{formatArea(space.area * space.quantity, measurementSystem)}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default SiteSpecificSpacesBreakdownTable;
